// extracted by mini-css-extract-plugin
module.exports = {"InfoSection":"InfoSection_InfoSection__2GB7I","icon":"InfoSection_icon__3bvad"};